define([
  'js/aofl-js/0.8.0/aofl-modules/__build/aofljs.min'
], function bookShelfAMD(aoflModules) {
  'use strict';
  var storeService = aoflModules.store;
  // TODO move to a seperate config file;
  var routeToStateMapping = {
    book_player: 'book_player_en',
    collection_view: 'categories_details_en',
    upsell: 'book_intercept_en'
  };
  var mapShelfAreasToApiEndpoints = {
    library: {
      endpoint: 'getShelves',
      args: {libraryType: 'default', extraShelves: ['swyk']}
    },
    categories: {
      endpoint: 'getShelves',
      args: {libraryType: 'categories', extraShelves: ['swyk']}
    },
    guidedReading: {
      endpoint: 'getShelves',
      args: {libraryType: 'guided_level'}
    },
    acceleratedReader: {
      endpoint: 'getShelves',
      args: {libraryType: 'accelerated_reader_level'}
    },
    lexile: {endpoint: 'getShelves', args: {libraryType: 'lexile_level'}},
    userShelf: {endpoint: 'getShelves', args: {libraryType: 'personal'}}
  };

  var shelfService = function shelfService(
    riqApiService,
    $state,
    cdnAssetService,
    $rootScope
  ) {
    var getBaseUrl = function() {
      return $rootScope.cdnBaseUrl;
    };

    riqApiService.setApiEndpoints({searchBooks: 'item_search'});

    var _getHref = function _getHref(route) {
      var page = routeToStateMapping[route.key];
      if (!page) console.error('Can not find url for this item route', route);
      return $state.href(page, route.stateParams);
    };

    var _getImageUrl = function _getImageUrl(item, shelfType) {
      // map to cdn value from resouceEnum
      return (
        getBaseUrl() +
        cdnAssetService.getItemIconPath({
          itemId: item.itemId,
          file: item.image,
          status: 'default',
          shelfType: shelfType
        })
      );
    };
    var _mapItemType = function _mapItemType(itemType, shelfType) {
      if (itemType === 'activity' && shelfType === 'book') {
        return 'flat';
      } else if (itemType === 'collection' && shelfType === 'book') {
        return 'collection';
      } else if (itemType === 'collection' && shelfType === 'flat') {
        return 'collection';
      } else if (itemType === 'collection' && shelfType === 'carousel') {
        return 'carousel';
      }

      return 'flat';
    };

    // TODO: Need to figure out a consistent naming convetion.
    var _mapItemImagePath = function _mapItemImagePath(itemType, shelfType) {
      if (itemType === 'collection' && shelfType === 'carousel') {
        return 'carousel';
      }
      return 'flat';
    };

    /**
     * Class for view shelf item
     * @param {Object} item api shelf model
     * @param {Object} itemType Type of item
     * @param {Object} shelfId Id of shelf
     * @param {String} shelfType Shelf type provided by api. book|carsouel
     * @param {String} collectionType Following types are: 'recommended'
     * @param {Boolean} isReadAgain if the item is the last read
     */
    var ShelfItemConstructor = function ShelfItemConstructor(
      item,
      itemType,
      shelfId,
      shelfType,
      collectionType,
      isReadAgain
    ) {
      var _route = Object.assign({}, item.route, {
        stateParams: {
          id: item.route.id,
          collectionId: shelfId,
          collectionType: collectionType,
          ref: shelfType
        }
      });
      this.itemType = _mapItemType(itemType, shelfType);
      this.shelfType = shelfType;
      this.collectionType = collectionType;
      this.isReadAgain = isReadAgain || false;
      this.route = _route;
      this.title = item.label || item.title;
      this.status = item.status;
      this.itemId = item.itemId;
      this.image = _getImageUrl(item, _mapItemImagePath(itemType, shelfType));
      this.tooltip = item.tooltip;
      this.id = _route.id;
      this.collectionId = shelfId;
      this.href = _getHref(_route);
      this.allStatuses = item.allStatuses || {};
      this.starsToDisplay = item.starsToDisplay;
    };

    /**
     * Factory method to create shelf items
     * @param {Object} data data object
     * @param {Object} data.item api shelfItem model
     * @param {String} data.itemType Type of item: 'book' 'video' 'pdf'
     * @param {String|Number} data.shelfId Id of shelf
     * @param {String} data.shelfType Shelf type provided by api. book|carsouel
     * @return {Object} shelf item view model
     */
    var createItem = function createItem(data) {
      return new ShelfItemConstructor(
        data.item,
        data.item.itemType,
        data.shelfId,
        data.shelfType || 'book',
        data.collectionType,
        data.item.isReadAgain
      );
    };

    var buildShelfItems = function buildShelfItems(data) {
      if (data.items) {
        return data.items
          .map(function(item) {
            return createItem(Object.assign({}, data, {item: item}));
          })
          .map(addOrder);
      }
      return [];
    };

    var ShelfConstructor = function ShelfConstructor(shelf) {
      this.title = shelf.label || shelf.title;
      this.id = shelf.collectionId;
      this.collectionTypeId = shelf.collectionTypeId;
      this.type = shelf.shelfType || 'book';
      this.decoration = shelf.decoration || {};
    };

    /**
     * Get Shelf items/books by Id
     * @param {String|Number} shelfIds List of shelf ids
     * @param {Object} optionalArgs Optional API arguments
     * @param {Boolean} cache Invalidate cache.
     * @param {Object} types map of shelf id to shelf type
     * @return {Promise} List of shelf items vm
     */
    var getShelfItems = function getShelfItems(
      shelfIds,
      optionalArgs,
      cache,
      types = {}
    ) {
      var args = Object.assign(
        {},
        {collectionIds: shelfIds},
        optionalArgs || {}
      );
      return riqApiService
        .get('getBooks', args, cache)
        .then(function(response) {
          try {
            storeService.commit([
              {
                mutationId: 'addBooksToShelves',
                stateAlias: 'bookShelvesContainer',
                payload: response.collections.map(collection => {
                  return {
                    ...collection,
                    ...{
                      books: buildShelfItems({
                        shelfId: collection.collectionId,
                        shelfType: types[collection.collectionId],
                        items: collection.items
                      })
                    }
                  };
                })
              }
            ]);
          } catch (e) {
            console.error('Error Failed to commit addBooksToShelves', e);
          }
          return response;
        });
    };

    function addOrder(entity, order) {
      return Object.assign(entity, {
        order: order
      });
    }

    var createShelf = function createShelf(data) {
      return new ShelfConstructor(data);
    };

    var getLibrary = function getLibrary(shelfArea) {
      if (!shelfArea || !mapShelfAreasToApiEndpoints[shelfArea]) {
        shelfArea = 'library';
        console.warn(
          'Shelf area is not defined falling back to loading library page'
        );
      }
      var endpointAction = mapShelfAreasToApiEndpoints[shelfArea];
      return riqApiService.get(
        endpointAction.endpoint,
        endpointAction.args,
        false
      );
    };

    return {
      getLibrary: getLibrary,
      buildShelfItems: buildShelfItems,
      createShelf: createShelf,
      getShelfItems: getShelfItems
    };
  };

  return shelfService;
});
